import { render, staticRenderFns } from "./cubes.vue?vue&type=template&id=36ff942c&scoped=true"
import script from "./cubes.vue?vue&type=script&lang=js"
export * from "./cubes.vue?vue&type=script&lang=js"
import style0 from "./cubes.vue?vue&type=style&index=0&id=36ff942c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ff942c",
  null
  
)

export default component.exports